import React from "react";
import FileRecordsPane, { FileRecordsConfig } from "./FileRecordsPane";
import { UserProfile } from "../../types/objects";

const CONFIG: FileRecordsConfig = {
    resource: "crmdocuments",
    title: "Dokumenty",
    subtitle: "Interní dokumenty a podklady ke klientům.",
    nounAccusative: "Dokument",
    emptyLabel: "V seznamu zatím nejsou žádné dokumenty.",
};

export default function Documents({ user }: { user: UserProfile }) {
    return <FileRecordsPane user={user} config={CONFIG} />;
}
